import VueSingleSelect from "vue-single-select";

import { axiosRequest } from '../../utils/Requests.js';
import { getReais, getCentavos} from '../../utils/Utils.js'

export default {
  components: { 
    VueSingleSelect
  },
  props: [ 'imobiliaria' ],
  data() {
    return {

      exibirSemResultados: false,

      pesquisarPorLocalizacao: true,
      codigoImovel: "",
      cidadeBairro: undefined,
      params: {
        operacao: 'ALUGUEL',
        cidade: undefined,
        bairro: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: undefined
      },
      comFundoCidade: true,
      styleBackgroundCity: {}
    }
  },
  computed: {
    possuiDestaquesAluguel() { return this.imobiliaria.destaques.aluguel && this.imobiliaria.destaques.aluguel.length > 0 },
    possuiDestaquesVenda() { return this.imobiliaria.destaques.venda && this.imobiliaria.destaques.venda.length > 0 },

    somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
    somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
    ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

    listaCidadesBairros() {
      let array = this.imobiliaria.cidades.map((cidade) => { return { nome: cidade.nome, id: cidade.id } })
      array = array.concat(this.imobiliaria.bairros.map((bairro) => { return { nome: bairro.nome + ' (' + bairro.cidade.nome + ')', id: bairro.cidade.id + "-" + bairro.id } }))
      return array
    },

    exibirCarrossel(){
      return this.imobiliaria.parametros.exibirCarrossel && this.imobiliaria.imagens && this.imobiliaria.imagens.length > 0
    },

    incluirLink(){
      if(this.imobiliaria.parametros.urlPersonalizada || this.imobiliaria.parametros.urlPersonalizada !== "") {
        return this.imobiliaria.parametros.urlPersonalizada;
      }
    }

  },
  watch: {
    cidadeBairro() {
      if(!this.cidadeBairro) {
        this.params.cidade = undefined
        this.params.bairro = undefined
        return
      }

      let array = this.cidadeBairro.id.toString().split("-")
      this.params.cidade = (array[0] ? array[0] : undefined)
      this.params.bairro = (array[1] ? array[1] : undefined)
    }
  },
  mounted() {
    this.params.operacao = (this.somenteVenda ? "COMPRA" : "ALUGUEL");

    if(this.comFundoCidade) {
      if(this.exibirCarrossel){
        this.styleBackgroundCity = {
          backgroundColor: '#e6e6e6',
          color: '#FFF',
          backgroundPosition: '100%',
          backgroundSize: 'cover'
        }
      } else {
        this.styleBackgroundCity = {
          backgroundImage: 'url(' + require('../../../assets/imagens/exemplo-cidade.jpg') + ')',
          color: '#FFF',
          backgroundPosition: '100%',
          backgroundSize: 'cover'
        }
      }
    }

    document.title =  "Imóveis, casas e apartamentos para venda e aluguel | " + this.imobiliaria.nome
  },
  methods: {
    getReais,
    getCentavos,
    irParaImovel(nome, id) {
      this.$router.push({ name: nome, params: { id: id } })
      this.rota = nome
    },
    pesquisar() {
      this.exibirSemResultados = false;
      if(this.pesquisarPorLocalizacao) {
        this.pagina = 0;

        this.$router.push(this.montarURL())
        this.listarImoveis()
      } else if(this.codigoImovel) {
        this.recuperarImovel()
      }
    },
    recuperarImovel() {
      this.loadingImoveis = true;

      axiosRequest.get("/imovel/cod/" + this.codigoImovel)
      .then((resultado) => {
        if(resultado.data.item.id) {
          this.$router.push('/imovel/' + resultado.data.item.id)
        } else {
          this.exibirSemResultados = true;
        }
      }).catch(() => {
        this.loadingImoveis = false;
      });
    },
    listarImoveis() {
      this.loadingImoveis = true;

      axiosRequest.post("/imoveis?pagina=" + this.pagina, this.params)
      .then((resultado) => {
        this.setData(resultado.data)
      }).catch(() => {
        this.pagina += 1
        this.loadingImoveis = false;
      });
    },
    configurarTipoPesquisa() {
      this.pesquisarPorLocalizacao = !this.pesquisarPorLocalizacao
      this.exibirSemResultados = false;
    },
    montarURL() {
      return {
        path: this.montarParametroURL(),
        query: { 
          pagina: this.pagina,
          valorMinimo: (this.params.valorMinimo ? this.params.valorMinimo : undefined),
          valorMaximo: (this.params.valorMaximo ? this.params.valorMaximo : undefined),
          quartos: (this.params.quartos ? this.params.quartos : undefined),
          area: (this.params.area ? this.params.area : undefined)
        }
      }
    },
    montarParametroURL() {
      var texto = "/imoveis/" + (this.params.operacao == "ALUGUEL" ? "alugar" : "comprar")

      let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.id == this.params.tipoImovel })[0];
      if(tipo) { texto += "/" + tipo.key }

      let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.id == this.params.cidade })[0];
      if(cidade) { texto += "/" + cidade.key }

      let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.id == this.params.bairro })[0];
      if(bairro) { texto += "/" + bairro.key }

      return texto;
    }
  }
}
